import gql from "graphql-tag"
import { useMutation } from "react-apollo"
import { CoveSignOutMutation, CoveSignOutMutationVariables } from "typings/types"

const SIGN_OUT = gql`
  mutation CoveSignOut {
    signOut {
      success
    }
  }
`

export const useSignOutMutation = () => useMutation<CoveSignOutMutation, CoveSignOutMutationVariables>(SIGN_OUT)
